import { useTranslation } from 'react-i18next';
import { documentLabel, safeDocumentUrl } from '../../utils/vinExtraction';
import { visuallyHiddenStyle } from './vinExtractionStyles';

/** One document link, opened in a new tab with no referrer; the label names its part and number, never the URL. */
const CarDocumentLink = ({ link }) => {
    const { t } = useTranslation('vinExtraction');
    // the parser already dropped anything but https:; checked again right at the href
    const href = safeDocumentUrl(link.url);
    if (!href) return null;
    const label = documentLabel(link.part, link.index);

    return (
        <li>
            <a href={href} target="_blank" rel="noopener noreferrer" referrerPolicy="no-referrer">
                {t(label.key, { number: label.number })}{' '}
                <i className="fi fi-rr-up-right-from-square" aria-hidden="true" />
                <span style={visuallyHiddenStyle}> {t('drawer.documents.newTab')}</span>
            </a>
        </li>
    );
};

export default CarDocumentLink;
